import { MaintenanceTaskInterface } from "../types";

export const filterMaintenanceTaskCreatedForOtherMaintenanceTaskProcessStep = (
  maintenanceTask: MaintenanceTaskInterface
): boolean => maintenanceTask.originalMaintenanceTaskProcessStepId != null;
